
















































    import { Component, Prop } from "vue-property-decorator";

    import { getBaseAllowedExts, validateFilesExt } from "@common/fileInputHelper";
    import DragNDropBase from "@share/common/controls/file/drag-n-drop/DragNDropBase.vue";
    import RoundCrossButton from "@share/common/buttons/RoundCrossButton.vue";
    import PlusIcon from "@share/common/PlusIcon.vue";
    import { getImageUrl } from "@common/ImageUrlHelper";
    import { AppercodeFile } from "@api/models/File";
	import {FileService} from "@share/common/services/files/FileService";
    import { RepositoryFabric } from "@api/repositories/RepositoryFabric";

    export interface FileValue<T = AppercodeFile> {
        file: T;
        url?: string | null;
    }

    export type FilesPayload<T = AppercodeFile> = FileValue<T>[];

    export enum FileInputType {
        image = "image",
        file = "file"
    }

    @Component({ components: { PlusIcon, RoundCrossButton } })

    export default class DragNDrop extends DragNDropBase {
        //EXAMPLE:
        //{ files: [new AppercodeFile({name: "Name of file"})], urls: [{ src: 'c434a040-197a-4692-b841-7a6743fb2491', name: "Name of file" }] }
        @Prop() value: FilesPayload;

        @Prop({ default: 5 }) maxSizeMb: number;
        @Prop({ required: true }) title: string;
        @Prop({ required: true }) height: number;
        @Prop({ default: false }) isMultiple: boolean;
        @Prop({ default: FileInputType.image }) type: FileInputType;
        @Prop({ default: false }) disabled: boolean;
        @Prop({ default: true }) isShowExt: boolean;
        @Prop({ default: true }) needFileObject: boolean;
        @Prop({ default: false }) needSelectButton: boolean;

        @Prop({
            default: getBaseAllowedExts,
            required: false
        }) allowedExts: string[];

        FileInputType = FileInputType;


        invalidExts: string[] = [];

        fileService: FileService;

        created() {
            this.fileService = new FileService(
                this.$store.state.session.backend,
                this.$repositories.get(RepositoryFabric.FILE)
            )
        }

        clear() {
            this.revokeObjectUrl();

            const emptyPaload: FilesPayload = []

            this.$emit("input", emptyPaload);

            this.clearInput();
        }

        revokeObjectUrl() {
            this.value.forEach(item => item.url && window.URL.revokeObjectURL(item.url));
        }

        getSingleImageUrl(urlOrId: string) {
            return urlOrId.includes('http') ? urlOrId : getImageUrl(undefined, urlOrId)
        }

        getInput() {
            return this.$el.getElementsByTagName("input")[0];
        }

        clearInput() {
            const $input = this.getInput();
            if($input) {
                $input.value = "";
            }
        }

        handleDrop(event: DragEvent) {
            this.handleFiles((event.dataTransfer?.files ?? null));
        }

        handleInput(event: Event) {
            this.handleFiles((event.target as HTMLInputElement).files);
        }

        handleFiles(fileList: FileList | null) {
            if(fileList?.length) {
                const files = Array.from(fileList);
                const validatedFiles = validateFilesExt(files, this.allowedExts);

                if(validatedFiles.invalid.length) {
                    this.invalidExts = validatedFiles.invalid.map(file => file.name)
                    return
                }

                this.revokeObjectUrl();

                const payload: FilesPayload<File> = files.map(file => {
                    return {
                        file: file,
                        url: this.needFileObject ? window.URL.createObjectURL(file) : null
                    }
                });

                if(payload.length) {
                    this.$emit("input", payload);
                }
            }
        }

        deleteFile(file: FileValue) {
            this.$emit("deleteFile", file);
        }

        async downloadFile(file: AppercodeFile) {
            await this.fileService.downloadFile(file)
        }

        get exts() {
            return this.isShowExt ? this.allowedExts.map(ext => '.' + ext).join(", ") : ''
        }

        get hasImageFile() {
            return this.value.length === 1 && this.type === FileInputType.image;
        }
}
